import { ColDef, GridApi } from 'ag-grid-community'; // or wherever you're importing from
import { DataTableOption } from '../../DataTable/DataTypes';

export  interface MyColDef<IRowtype = any> extends ColDef {

  /* made as array[] for multiple params in single col - like dateRange */
  searchingParam?: string[];
  sortingParam?: string;
  isDetailLink?: boolean;         
  isCopyable?: boolean;          
  backendFilterType?: 'text' | 'select' | 'boolean_toggle' | 'daterange' | 'multiselect' | '' | 'date';
  /*
  * lazyLoadParamKey is used to pass the query param to be set true/false in the api for lazy loading the column on visible
  */    
  lazyLoadParamKey?: string;
}
   
export interface IAGGridDataTableEngineProps {
  columns: MyColDef[];
  fetchUrl?: string;
  pagination: boolean;
  dataTableOption : DataTableOption;
  refresh: boolean;
  exportInit?: Number;
  name: string; // Optional name prop for identification
  selectedDevices?: string[];
  defaultFilterQueryParams?: URLSearchParams;
  selectedFirmware?: string[];
  activeStep?: number;
} 

export interface IDataTableContextType {
  TableView: View;
  setTableView: (value: View) => void;
  VIEW_FIELDS_REF: React.MutableRefObject<Record<View, Set<string>> | null>;
  COLUMN_FIELDS_REF: React.MutableRefObject<Map<string, any> | null>;
  visibleColumnList: string[]; 
  setVisibleColumnList: (value: string[]) => void; 
  hiddenColumnList: string[]; 
  setHiddenColumnList: (value: string[]) => void; 
  
  columnVisible:string;
  setColumnVisible: (value: string) => void;
  columnHidden:string;
  setColumnHidden: (value: string) => void;
  
  selectedRowCount: number;                                  
  setSelectedRowCount: (count: number) => void;              

  gridApi?: GridApi;
  setGridApi?: (api: GridApi) => void;  
  columnWidthsRef: React.MutableRefObject<Map<string, number>>;

  floatingFilterValueMap: React.MutableRefObject<Map<string, string>>;

  isSelectAllActive: React.MutableRefObject<Boolean>;
  totalEntriesRef: React.MutableRefObject<number>;
  fetchUrlRef: React.MutableRefObject<string>;
  fetchUrlParamsRef: React.MutableRefObject<URLSearchParams>;
  queryParamsStringRef: React.MutableRefObject<string>;
  primaryKeyRef: React.MutableRefObject<string>;
  selectedRowData: React.MutableRefObject<Map<string, any>>;
  deSelectedRowData: React.MutableRefObject<Map<string, any>>;
  maxContentHeight: number;
  setMaxContentHeight: (height: number) => void;
  rowHeight?: number;
  setRowHeight?: (rowHeight: number) => void;
  ROW_HEIGHT_DEFAULT?: number;
  ROW_HEIGHT_OPTION_PADDING_TOP?: number;
}

export enum View {
  Basic,
  Detailed,
  Expanded
}

export enum LoaderType {
  BoxShortWidth = "BoxShortWidth",
  BoxFullWidth = "BoxFullWidth",
  Number = "number",
  Date = "date",
  Dropdown = "dropdown",
  ActionButton = "actionButton",
  Icon = "icon",
  State = "state",
  Image = "image",
}